import {
    getOrder,
    listOrders
} from './queries';
import {
    createOrder,
    deleteOrder,
    updateOrder,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {Order} from "../types.ts";
import { billingApiClient } from "../../billing-api-integration";
import {ListRecordsQuery} from "../../../types";


export type ListOrders = {
    listOrders: { items: Order[], nextToken: string | null }
}

export type GetOrder = {
    getOrder: Order
}

export type CreateOrder = {
    createOrder: Order
}

export type UpdateOrder = {
    updateOrder: Order
}

export type DeleteOrder = {
    deleteOrder: string
}


const client = billingApiClient;

const normalizeFilter = (filter: { [key: string]: string }) =>
    Object.keys(filter).reduce((acc: { [key: string]: string }, key) => {
        if (filter[key] !== '' && filter[key] !== undefined) {
            acc[key] = filter[key];
        }
        return acc;
    }, {});

export const fetchRecords = async (query: ListRecordsQuery) => {
    const { filter, ...rest } = query;
    const transformedFilter = filter ? normalizeFilter(filter as { [key: string]: string }) : {};

    const response = await client.graphql<GraphQLQuery<ListOrders>>({
                                                                        query: listOrders,
                                                                        variables: {
                                                                            ...rest,
                                                                            ...(Object.keys(transformedFilter).length ? { filter: transformedFilter } : {})
                                                                        },
                                                                    });
    return {
        items: response.data?.listOrders.items,
        nextToken: response.data?.listOrders.nextToken,
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetOrder>>({
                                                                      query: getOrder,
                                                                      variables: {id: id},
                                                                  });
    return response.data?.getOrder;
};

// Inputs are WHITELISTED to the billing-api input types (orders.graphql). AppSync rejects
// the whole call for one undeclared field, and the edit drawer hands back a loaded row.
//
// CreateOrderInput: customerId!, subscriptionId, providerKey!, amount!, currency!, description, status
// Only the two fields any caller collects today are sent. providerKey, amount and currency
// are required, so a create still fails: whether the console should send them is FNP-1912,
// a money-path decision. Do not add them here without it.
export const buildCreateOrderInput = (values: Partial<Order>) => ({
    customerId: values.customerId,
    subscriptionId: values.subscriptionId,
});

// UpdateOrderInput: id!, customerId!, subscriptionId!, status
// `status` is loaded for display but deliberately not sent: the edit form does not offer it,
// and sending it would make a save write a field it never used to.
export const buildUpdateOrderInput = (id: string, values: Partial<Order>) => ({
    id,
    customerId: values.customerId,
    subscriptionId: values.subscriptionId,
});

export const add = async (values: Partial<Order>) => {
    const response = await client.graphql<GraphQLQuery<CreateOrder>>({
                                                                         query: createOrder,
                                                                         variables: {input: buildCreateOrderInput(values)},
                                                                     });
    return response.data?.createOrder;
};

export const update = async (id: string, values: Partial<Order>) => {
    const response = await client.graphql<GraphQLQuery<UpdateOrder>>({
                                                                         query: (updateOrder),
                                                                         variables: {input: buildUpdateOrderInput(id, values)},
                                                                     });
    return response.data?.updateOrder;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteOrder>>({
                                                                         query: (deleteOrder),
                                                                         variables: {input: {id: id}},
                                                                     });
    return response.data?.deleteOrder;
};
